module.exports = __webpack_public_path__ + "static/media/departure.ba34150d.png";